module.exports = __webpack_public_path__ + "img/flag.013fa967.png";